/**
 * @voltxampere/ui — White LED 5mm (Sprint 51-1 polish, dedicated variant)
 *
 * Standard 5mm white LED — phosphor-coated InGaN blue + yellow phosphor,
 * V_F ≈ 3.4V at 20mA. Used in flashlights, illumination, white-on-black
 * displays.
 *
 * Engine zero-diff invariant honored — schemaType `led`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { led } from "../led.js";
export const ledWhite5mm = {
    id: "led-white-5mm",
    nameTr: "LED Beyaz 5mm (genel)",
    nameEn: "LED White 5mm (generic)",
    shortcut: "D",
    category: "active",
    viewBox: led.viewBox,
    terminals: led.terminals,
    defaultLabel: "D",
    defaultValue: "WHITE",
    schemaType: "led",
    defaultParams: {
        is: 1e-12,
        n: 3,
        vForward: 3.4,
        color: "white",
        package: "T-1¾ (5mm)",
        wavelengthNm: 0,
        luminousIntensityMcd: 6000,
        cct: 6500,
    },
    renderSVG: () => led.renderSVG(),
};
//# sourceMappingURL=led-white-5mm.js.map